<template>
  <!-- Mobile-only tab row for switching between pill sections. Hidden on desktop via CSS. -->
  <li role="none" class="pills-tabs__section-tabs-row">
    <button
      v-for="(section, si) in sections"
      :key="section.name"
      role="tab"
      :aria-selected="activeIndex === si"
      :class="['pills-tabs__section-tab', { 'pills-tabs__section-tab--active': activeIndex === si }]"
      @click="$emit('select', si)"
    >
      {{ section.name }}
    </button>
  </li>
</template>

<script lang="ts" setup>
interface Section {
  name: string
}

interface Props {
  sections: Section[]
  activeIndex: number
}

defineProps<Props>()
defineEmits<{ select: [index: number] }>()
</script>

<style lang="scss" scoped>
.pills-tabs__section-tabs-row {
  display: flex;
  gap: 0;
  width: 100%;
  border-bottom: 1px solid var(--paper-300);
  margin-bottom: 4px;

  @media (min-width: $breakpoint-lg) {
    display: none;
  }
}

.pills-tabs__section-tab {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  padding: 8px 16px 10px;
  font-size: var(--font-size-paragraph-m);
  font-weight: 600;
  color: var(--navy-800);
  cursor: pointer;
  transition: color 0.2s ease;

  &--active {
    color: var(--cobalt-600);
    border-bottom-color: var(--cobalt-600);
  }
}
</style>
